// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__52Bp6","form":"styles_form__1lKqL"};